export class DadoBancarioChavePix {
    dadoBancarioChavePixId: number = 0;
    chavePixTipo: number = 0;
    chavePix: string = '';
    dadoBancarioId: number = 0;
    saguiClienteId: number = 0;
}